import { connect } from "react-redux";
import Transaction from "./Transaction";
import { bindActionCreators } from "redux";
import {walletListing, transactionListing} from "../../../services/redux/Wallet/action";

const mapStateToProps = (state) => ({
    listing : state.Wallet.listing,
    transaction : state.Wallet.transaction,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        walletListing,
        transactionListing
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);